import { useState } from "react";
import { inputCls, labelCls, FormActions } from "./common";

const vide = { nom: "", role: "", texte: "", ordre: 10 };

export const TemoignageForm = ({ initial, onSave, onCancel, saving }) => {
  const [f, setF] = useState(initial || vide);
  const set = (champ) => (e) => setF({ ...f, [champ]: e.target.value });

  const soumettre = (e) => {
    e.preventDefault();
    onSave({ ...f, ordre: Number(f.ordre) });
  };

  return (
    <form onSubmit={soumettre} className="space-y-5" data-testid="temoignage-form">
      <div className="grid gap-5 md:grid-cols-2">
        <div>
          <label htmlFor="tf-nom" className={labelCls}>Nom *</label>
          <input id="tf-nom" required minLength={2} value={f.nom} onChange={set("nom")} className={inputCls} placeholder="Awa Diallo" data-testid="temoignage-form-nom" />
        </div>
        <div>
          <label htmlFor="tf-role" className={labelCls}>Rôle / contexte *</label>
          <input id="tf-role" required minLength={2} value={f.role} onChange={set("role")} className={inputCls} placeholder="Travailleuse autonome — couture" data-testid="temoignage-form-role" />
        </div>
      </div>
      <div>
        <label htmlFor="tf-texte" className={labelCls}>Témoignage *</label>
        <textarea id="tf-texte" required minLength={10} rows={5} value={f.texte} onChange={set("texte")} className={`${inputCls} resize-y`} data-testid="temoignage-form-texte" />
      </div>
      <div>
        <label htmlFor="tf-ordre" className={labelCls}>Ordre d'affichage</label>
        <input id="tf-ordre" type="number" min="0" step="1" value={f.ordre} onChange={set("ordre")} className={inputCls} data-testid="temoignage-form-ordre" />
      </div>
      <FormActions saving={saving} onCancel={onCancel} />
    </form>
  );
};
